// Central config for milestone badge colors. Edit here to retheme any
// milestone kind across the projection-details views.
export const milestoneColors: Record<ProjectionMilestoneKind, { bg: string; text: string }> = {
  'ltc-begins':     { bg: 'bg-primary/10',  text: 'text-primary' },
  'claim-start':    { bg: 'bg-indigo-100',  text: 'text-indigo-700' },
  'ep-lump':        { bg: 'bg-emerald-100', text: 'text-emerald-700' },
  'pool-exhausted': { bg: 'bg-rose-100',    text: 'text-rose-700' },
  'min-db-reached': { bg: 'bg-amber-100',   text: 'text-amber-700' },
  'phase-change':   { bg: 'bg-violet-100',  text: 'text-violet-700' },
  'env-change':     { bg: 'bg-sky-100',     text: 'text-sky-700' },
  'anniversary':    { bg: 'bg-gray-100',    text: 'text-gray-600' },
  'out-of-pocket':  { bg: 'bg-rose-50',     text: 'text-rose-700' },
};

export function milestoneBadgeClass(kind: ProjectionMilestoneKind): string {
  const c = milestoneColors[kind];
  return `${c.bg} ${c.text}`;
}
